export const LANDING = '/';
export const HOME = '/home';
export const SIGN_UP = '/signup';
export const SIGN_IN = '/signin';
